import { NextRouter } from 'next/router';

export const getQueryValue = (router: NextRouter, key: string): string | undefined => {
  if (router.query[key] !== undefined) {
    return router.query[key] as string;
  }

  const matches = router.query[key] || router.asPath.match(new RegExp(`${key}=([^&]*)`)) || [];
  return matches?.length > 0 ? decodeURIComponent(matches[1]) : undefined;
};
